import * as dateUtils from './datePicker-date-utils';
const precisionLengthRecord = {
    year: 1,
    month: 2,
    day: 3,
    hour: 4,
    minute: 5,
    second: 6,
};
export const convertDateToStringArray = (date, precision) => {
    const datePrecision = precision;
    const stringArray = dateUtils.convertDateToStringArray(date);
    return stringArray.slice(0, precisionLengthRecord[datePrecision]);
};
export const convertStringArrayToDate = (value, precision) => {
    return dateUtils.convertStringArrayToDate(value);
};
export const generateDatePickerColumns = (selected, min, max, precision, unit) => {
    return dateUtils.generateDatePickerColumns(selected, min, max, precision, unit);
};
